// TrustPromise.js — answers the "is this agency real?" fear in the first
// scroll: who we place students with, where our office is, who we are.
// Office address comes from the CMS (General Settings), like the footer.
import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, MapPin, Users } from 'lucide-react';
import { useSiteContent } from '../context/SiteContentContext';
import './TrustPromise.css';

export default function TrustPromise() {
  const { globalContent } = useSiteContent();
  const address = (globalContent.address || '').trim();

  return (
    <section className="trust-promise" aria-labelledby="trust-promise-heading">
      <div className="trust-promise-inner">
        <h2 id="trust-promise-heading" className="trust-promise-title">Our promise to parents</h2>
        <div className="trust-promise-grid">
          <div className="trust-promise-item">
            <ShieldCheck className="trust-promise-icon" aria-hidden="true" />
            <h3>Recognised universities only</h3>
            <p>
              We only place students at universities in mainland Turkey that are recognised by YÖK,
              Turkey's Council of Higher Education.
            </p>
          </div>
          <div className="trust-promise-item">
            <MapPin className="trust-promise-icon" aria-hidden="true" />
            <h3>A real office you can visit</h3>
            <p>{address || 'Our office is in Bulawayo, Zimbabwe.'}</p>
          </div>
          <div className="trust-promise-item">
            <Users className="trust-promise-icon" aria-hidden="true" />
            <h3>Real people, by name</h3>
            <p>
              Meet the team who will answer your messages on our <Link to="/about">About page</Link>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
